import { LiveMeetingAttendanceConfirmationStatusEnum } from 'app/types/cards/LiveVideoCard';
import { IconsTypes } from 'components/icons';
import { ClosingTypes } from 'features/contents';
import { DownloadsItemState } from 'features/downloads';
import { ModuleGroupState } from 'features/modules';
import { ProductClassPaymentTypeEnum, ProductVisibilityEnum } from 'features/products';
import { ContentPartnerIntoProductCourseRequest } from 'features/products/types/ContentPartnerIntoProductCourseRequest';
import { TagResponse } from 'features/tags';

export enum EventStatusEnum {
  Unspecified = 0,
  Draft = 1,
  New = 2,
  Enrollment = 3,
  Checkin = 4,
  Open = 5,
  Closed = 6,
}

export enum EventTypeEnum {
  Unspecified = 0,
  Online = 1,
  Presential = 2,
}

export const EventTypeEnumMapping: Record<EventTypeEnum, string> = {
  [EventTypeEnum.Unspecified]: 'Não especificado',
  [EventTypeEnum.Online]: 'Online',
  [EventTypeEnum.Presential]: 'Presencial',
};

export interface ProductClassesItem {
  productUuid: string;
  productClasses: string[];
}

export enum ExpirationTypes {
  Unspecified = 0,
  TimeAfterIssued = 1,
  SpecificDate = 2,
}

export interface ProductEventResponse {
  eventExternalId: string;
  headlineText: string;
  startDate: string;
  endDate: string;
  showDate: boolean;
  eventType: EventTypeEnum;
  eventStatus: EventStatusEnum;
  locationName: string;
  locationAddress: string;
  locationMapLink: string;
  locationMapImage: string;
  allowGuests: boolean;
  allowInterestList: boolean;
  enrollmentLimit: number;
  enrollmentStartDate: string;
  enrollmentEndDate: string;
  requiresCheckin: boolean;
  requiresCheckinForCertification: boolean;
  requiresCheckinAllContentsForCertification: boolean;
  productClasses: ProductClassesItem[];
  downloads: DownloadsItemState[];
  commentContentUuid: string;
  isHighlighted: boolean;
  isNew: boolean;
  isEnabled: boolean;
  hat: string;
  name: string;
  description: string;
  slug: string;
  coverImageUrl: string;
  mobileCoverImageUrl: string;
  cardImageUrl: string;
  productVisibility: ProductVisibilityEnum;
  productClassPaymentTypeEnum: ProductClassPaymentTypeEnum;
  detailedAccess: boolean;
  showCard: boolean;
  checkinLiveMeetingUuid: string;
  attendanceConfirmationCode: string;
  attendanceConfirmationCodeExpiresAt: string;
  attendanceConfirmationQRCode: string;
  attendanceConfirmationUrl: string;
  attendanceConfirmationStatus: LiveMeetingAttendanceConfirmationStatusEnum;

  class: {
    classNumber: number;
    description: string;
    isEnabled: boolean;
    closingType: ClosingTypes;
    closingDate: string;
    closingDays: string;
    closingDaysEnrollment: string;
    allowEnrollments: boolean;
    automaticEnrollment: boolean;
    allowOnDemandEnrollments: boolean;
    computeLiveAssessments: boolean;
    realTimeAssessments: boolean;
    certificateStudents: boolean;
    minimalCertificatePerc: number;
    minimalCertificateDate: string;
    certificateExpirationType: ExpirationTypes;
    certificateExpirationDate: string;
    certificateExpirationDays: string;
    certificateWorkloadHours: string;
    certificateTemplateUuid: string;
    intervalForVideoCheckpoints: number;
    productClassVisibility: number;
    productClassPaymentTypeEnum: ProductClassPaymentTypeEnum;
    isActive: boolean;
    downloads: DownloadsItemState[];
    externalCheckoutUrl: string;
    externalCheckoutPrice: string;
    externalCheckoutInstallment: string;
    externalCheckoutInstallmentValue: string;
  };
  tags: TagResponse[];
  contentPartners: ContentPartnerIntoProductCourseRequest[];
  groups: ModuleGroupState[];
  //classifications: ClassificationItem[];
}

export interface EventCardProps {
  uuid: string;
  name: string;
  hat: string;
  slug: string;

  hatName: string;
  startDate: string;
  checkinStartDate: string;
  enrolled: boolean;
  allowEnrollemnts: boolean;
  buttonLabel: string;
  buttonIcon: IconsTypes;
  image?: string;
  commentContentUuid?: string;

  size?: 'small' | 'default' | 'large';
  theme?: 'light' | 'dark';
  hideButton: boolean;

  disabled: boolean;
}
